import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { UserProfile } from '../models';
import { adUserActions } from '../actions';

export const adalUserAdapter: EntityAdapter<UserProfile> = createEntityAdapter<UserProfile>({
  selectId: (item: UserProfile) => parseUserEmail(item.userPrincipalName),
  sortComparer: (a: UserProfile, b: UserProfile) => {
    if (a.displayName && b.displayName) {
      return a.displayName.localeCompare(b.displayName);
    }
  }
});

export function parseUserEmail(email: string): string {
  email = email ? email.toLowerCase() : '';
  email = email ? email.replace('mtvn', 'viacom') : '';
  return email;
}

export interface AdUserState extends EntityState<UserProfile> {
  loading: boolean;
  currentUser: UserProfile;
}

export const INIT_STATE: AdUserState = adalUserAdapter.getInitialState({
  loading: false,
  currentUser: null
});

/**
 * Ngrx reducer for the auth state, this updates the state for the login/logout success actions
 *
 * @export
 * @param [state=INITIAL_STATE]
 * @param action
 * @returns { Auth } Updated state or the default state
 */
export function adUserReducer(
  state: AdUserState = INIT_STATE,
  action: adUserActions.Action
): AdUserState {
  switch (action.type) {
    case adUserActions.LOAD_AD_USER: {
      return { ...state, loading: true };
    }

    case adUserActions.LOAD_AD_USER_SUCCESS: {
      return {
        ...adalUserAdapter.addOne(action.payload, state),
        loading: false
      };
    }
    case adUserActions.LOAD_CURRENT_USER_SUCCESS: {
      return {
        ...state,
        currentUser: action.payload
      };
    }

    case adUserActions.LOAD_AD_USER_FAILED: {
      return { ...state, loading: false };
    }

    default: {
      return state;
    }
  }
}

export const getAdUserLoading: (AdUserState) => boolean = (state: AdUserState) => state.loading;
